/**
 * Infrastructure template download hook.
 */

import { useState, useCallback } from 'react'
import { downloadInfrastructureTemplate } from '../../services/endpoints'
import type { TemplateFormat, TemplateDownloadQuery } from '../../types/infrastructure'

interface UseInfrastructureTemplatesResult {
  downloading: boolean
  error: string | null
  downloadTemplate: (
    caseId: string,
    format: TemplateFormat,
    options?: TemplateDownloadQuery
  ) => Promise<boolean>
  clearError: () => void
}

export function useInfrastructureTemplates(): UseInfrastructureTemplatesResult {
  const [downloading, setDownloading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const downloadTemplate = useCallback(
    async (
      caseId: string,
      format: TemplateFormat,
      options?: TemplateDownloadQuery
    ): Promise<boolean> => {
      setDownloading(true)
      setError(null)

      try {
        await downloadInfrastructureTemplate(caseId, format, options)
        return true
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to download template')
        return false
      } finally {
        setDownloading(false)
      }
    },
    []
  )

  const clearError = useCallback(() => {
    setError(null)
  }, [])

  return {
    downloading,
    error,
    downloadTemplate,
    clearError,
  }
}
